import { Helmet } from "react-helmet";

interface PageTitleProps {
  title?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title = "OpenUp Admin" }) => (
  <Helmet title={`${title} - OpenUp Admin`} />
);

export default PageTitle;
